import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-bar"
  }, [_vm.picker ? _c('div', {
    staticClass: "search-bar-left",
    on: {
      "click": function ($event) {
        _vm.pickerShow = true;
      }
    }
  }, [_c('div', {
    staticClass: "search-bar-left-text"
  }, [_c('div', {
    class: {
      'font-size-h2-normal': _vm.sizeflag
    }
  }, [_vm._v(" " + _vm._s(_vm.pickerCurrName) + " ")])]), _c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-down",
    attrs: {
      "type": "ios-arrow-down",
      "size": "13",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13",
      "height": "13",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M396.6 160l19.4 20.7L256 352 96 180.7l19.3-20.7L256 310.5z"
    }
  })]), _c('PopupPicker', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data": _vm.pickerList,
      "show": _vm.pickerShow,
      "show-name": "",
      "columns": 1
    },
    on: {
      "on-hide": function ($event) {
        _vm.pickerShow = false;
      },
      "on-change": function ($event) {
        return _vm.$emit('on-ok', _vm.currValue, _vm.pickerCurrValue[0]);
      }
    },
    model: {
      value: _vm.pickerCurrValue,
      callback: function ($$v) {
        _vm.pickerCurrValue = $$v;
      },
      expression: "pickerCurrValue"
    }
  })], 1) : _vm._e(), _vm.input ? _c('div', {
    staticClass: "search-bar-bg"
  }, [_c('div', {
    staticClass: "search-bar-icon",
    on: {
      "click": function ($event) {
        return _vm.$refs['search-bar-input'].focus();
      }
    }
  }, [_c('img', {
    staticClass: "search-bar-icon-i",
    attrs: {
      "src": "/spa_static_mobile/icon/find24_24@3x.png",
      "alt": ""
    }
  })]), _c('form', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.$emit('on-ok', _vm.currValue, _vm.pickerCurrValue[0]);
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currValue,
      expression: "currValue"
    }],
    ref: "search-bar-input",
    staticClass: "search-bar-input",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.currValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.currValue = $event.target.value;
      }
    }
  })])]) : _vm._e(), _vm.detail ? _c('div', {
    staticClass: "search-bar-right",
    on: {
      "click": function ($event) {
        _vm.detailShow = !_vm.detailShow;
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSearch,
      expression: "!isSearch"
    }],
    staticClass: "search-bar-right-img",
    attrs: {
      "src": "/spa_static_mobile/icon/filter26_26@3x.png"
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSearch,
      expression: "isSearch"
    }],
    staticClass: "search-bar-right-img",
    attrs: {
      "src": "/spa_static_mobile/icon/clickfilter26_26@3x.png"
    }
  }), _c('div', {
    staticClass: "search-bar-right-text font-size-h3-large",
    class: {
      active: _vm.isSearch
    }
  }, [_vm._v(i18n.tc("343"))])]) : _vm._e()]), _c('div', {
    staticClass: "search-detail",
    style: {
      height: _vm.detailShow ? _vm.height + 4 + "rem" : '0'
    }
  }, [_c('div', {
    staticClass: "search-detail-content",
    style: {
      height: _vm.height + "rem"
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "search-detail-button"
  }, [_c('div', {
    staticClass: "search-detail-button-left",
    on: {
      "click": function ($event) {
        _vm.$emit('on-reset'), _vm.$emit('on-detail-ok');
      }
    }
  }, [_c('XButton', {
    attrs: {
      "type": "default",
      "action-type": "button"
    }
  }, [_vm._v(i18n.tc("344"))])], 1), _c('div', {
    staticClass: "search-detail-button-right",
    on: {
      "click": function ($event) {
        _vm.$emit('on-detail-ok'), _vm.detailShow = false;
      }
    }
  }, [_c('XButton', {
    attrs: {
      "type": "primary",
      "action-type": "button"
    }
  }, [_vm._v(i18n.tc("12"))])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailShow,
      expression: "detailShow"
    }],
    staticClass: "mask",
    style: {
      opacity: _vm.detailShow ? '.5' : '0',
      zIndex: _vm.detailShow ? '2' : '-1'
    },
    on: {
      "click": function ($event) {
        _vm.detailShow = false;
      }
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };